<template>
    <div id="Geren">
        <div class="without">
            <el-link class="withoutcloe" type="primary">个人认证</el-link>
        </div>
        <div class="without-xian">
        </div>
        <div class="basic">
            基础信息
        </div>
        <el-row>
            <el-col :span="12">
                <el-form ref="form" :label-position="labelPosition" :model="form" label-width="100px">
                    <el-form-item label="用户姓名">
                        <el-input size="medium" :readonly="!status" v-model="companyName" placeholder="输入姓名">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="身份证号">
                        <el-input size="medium" :readonly="!status" v-model="businessRegistrationNumber"
                            placeholder="输入身份证号">
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="12"></el-col>
        </el-row>
        <div class="basic">
            身份证信息
        </div>
        <el-row class="mkouasa" :gutter="24">
            <el-col :span="10">
                <div class="grid-content bg-purple">
                    <div class="moloua">
                        身份证人像面
                    </div>
                    <div class="mkouas">
                        <el-upload class="avatar-uploader" action="/" :show-file-list="false" :auto-upload="false"
                            :on-change="imgChange1">
                            <img v-if="img1" :src="img1" class="avatar">
                            <i v-if="!img1" class="el-icon-plus avatar-uploader-icon"></i>
                            <div v-if="!img1" class="avatar-uploader-txt">
                                <img src="../../assets/id_02.png">
                            </div>
                        </el-upload>
                    </div>
                </div>
            </el-col>
            <el-col :span="10">
                <div class="grid-content bg-purple">
                    <div class="moloua">
                        身份证国徽面
                    </div>
                    <div class="mkouas">
                        <el-upload class="avatar-uploader" action="/" :show-file-list="false" :auto-upload="false"
                            :on-change="imgChange2">
                            <img v-if="img2" :src="img2" class="avatar">
                            <i v-if="!img2" class="el-icon-plus avatar-uploader-icon"></i>
                            <div v-if="!img2" class="avatar-uploader-txt">
                                <img src="../../assets/id_01.png">
                            </div>
                        </el-upload>
                    </div>
                </div>
            </el-col>
        </el-row>

        <!-- <el-row style="margin-top: 15px;">
            <el-col :span="12">
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="身份证人像面">
                        <el-upload :disabled="!status" class="avatar-uploader" action="/" :show-file-list="false"
                            :auto-upload="false" :on-change="imgChange1">
                            <img v-if="img1" :src="img1" class="avatar">
                            <i v-if="!img1" class="el-icon-plus avatar-uploader-icon"></i>
                            <div v-if="!img1" class="avatar-uploader-txt">点击上传</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

        <el-row style="margin-top: 15px;">
            <el-col :span="12">
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="身份证国徽面">
                        <el-upload :disabled="!status" class="avatar-uploader" action="/" :show-file-list="false"
                            :auto-upload="false" :on-change="imgChange2">
                            <img v-if="img2" :src="img2" class="avatar">
                            <i v-if="!img2" class="el-icon-plus avatar-uploader-icon"></i>
                            <div v-if="!img2" class="avatar-uploader-txt">点击上传</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row> -->

        <el-row style="margin-top: 15px;">
            <el-col :span="12">
                <el-form ref="form" :label-position="labelPosition" :model="form" label-width="100px">
                    <el-form-item label="有效期">
                        <el-input v-if="!status" size="medium" :readonly="!status" v-model="companyPermitSj"
                            placeholder="选择日期时间">
                        </el-input>
                        <el-date-picker v-else size="medium" value-format="yyyy-MM-dd" v-model="companyPermitSj"
                            type="date" placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

        <el-row>
            <div style="margin-top: 15px;">
                <el-form ref="form" :label-position="labelPosition" :model="form" label-width="100px">
                    <el-form-item label="业务描述">
                        <el-input :readonly="!status" placeholder="输入业务描述" type="textarea" v-model="note"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </el-row>
        <el-form ref="form" :model="form" label-width="100px"
            v-if="$store.state.isNotCertifiedPerson==7||$store.state.isNotCertifiedPerson==0">
            <el-form-item>
                <el-button style="float: left;" label-position="left" type="primary" @click="onSubmit">
                    {{$store.state.isNotCertifiedPerson==7?'重新认证':'提交认证'}}
                </el-button>
            </el-form-item>
        </el-form>
        <div class="mkousssa" v-if="$store.state.isNotCertifiedPerson==0">
            提交认证后，请等待1-3个工作日审核{{$store.state.isNotCertifiedPerson}}
        </div>
        <div class="mkousssa" v-if="$store.state.isNotCertifiedPerson==5">
            正在审核
        </div>
        <div class="err" v-if="$store.state.isNotCertifiedPerson==7">
            <div style="font-weight: bold; padding-bottom: 12px;">认证失败</div>
            认证失败原因：{{content}}
        </div>
    </div>
    </div>
</template>

<script>
    import citys from '../../assets/citys.json'
    export default {
        name: "Company",
        data() {
            return {
                labelPosition: 'left',

                status: false,
                form: {},

                state: '',

                companyName: null,
                businessRegistrationNumber: null,
                companyPermitSj: null,
                note: null,

                content: null,

                imgFiles: { //图片文件
                    files1: '',
                    files2: '',
                },

                img1: null,
                img2: null,


                citys: citys,

                value: null,
            };
        },
        created() {
            if (this.$route.query.id) {
                this.getCompanyInfo();
                this.getUser();
            } else {
                this.status = true;
            }
        },
        methods: {
            imgChange1(file) {
                this.imgFiles.files1 = file.raw;
                this.img1 = URL.createObjectURL(file.raw);
            },
            imgChange2(file) {
                this.imgFiles.files2 = file.raw;
                this.img2 = URL.createObjectURL(file.raw);
            },
            onSubmit() {
                var that = this;
                var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
                if (!that.companyName) {
                    this.$message({
                        message: '请输入姓名',
                        type: 'warning'
                    });
                    return false;
                }
                if (that.businessRegistrationNumber.length != 15 && that.businessRegistrationNumber.length != 18) {
                    this.$message({
                        message: '请输入正确的身份证号',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.imgFiles.files1) {
                    this.$message({
                        message: '身份正面文件不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.imgFiles.files2) {
                    this.$message({
                        message: '身份证反面文件不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.note) {
                    this.$message({
                        message: '业务描述不能为空',
                        type: 'warning'
                    });
                    return false;
                }

                var form = new FormData();

                form.append('files1', that.imgFiles.files1, that.imgFiles.files1.name);
                form.append('files2', that.imgFiles.files2, that.imgFiles.files2.name);


                form.append('companyName', that.companyName);
                form.append('businessRegistrationNumber', that.businessRegistrationNumber);
                form.append('companyPermitSj', that.companyPermitSj);
                form.append('note', that.note);
                form.append('userId', that.$store.state.userId);
                form.append('sysType', 1);

                that.request.post(that.$store.state.httpUrl + 'mobileInterf/makeCertificationPersonH5', form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    if (response.status == 200) {
                        that.status = false;
                        that.getUser();
                    } else {
                        this.$message({
                            message: responseces.msg,
                            type: 'error'
                        });
                    }
                })
            },
            getUser() {
                let that = this;

                this.request.get(this.$store.state.httpUrl + "userDetails/findUserPerson", {
                    params: {
                        id: this.$store.state.userId,
                        flag: this.$store.state.isPerson
                    }
                }).then(res => {
                    if (res.status == 200) {
                        this.info = res.data;
                        sessionStorage.setItem("isLogin", "1");
                        sessionStorage.setItem("isMain", 1);

                        sessionStorage.setItem("isNotCertified", res.data.isNotCertified); //认证字段
                        sessionStorage.setItem("isNotCertifiedPerson", res.data.isNotCertifiedPerson); //认证字段
                        that.$store.state.isNotCertified = res.data.isNotCertified;
                        that.$store.state.isNotCertifiedPerson = res.data.isNotCertifiedPerson;

                        sessionStorage.setItem("state", JSON.stringify(that.$store.state));

                        sessionStorage.setItem("userId", res.data.userId);
                        sessionStorage.setItem("nickname", res.data.nickname);

                        that.$store.state.userId = sessionStorage.getItem('userId');
                        that.$store.state.nickname = sessionStorage.getItem('nickname');
                        that.$store.state.telNum = sessionStorage.getItem('phone');
                        that.$store.state.businessNo = sessionStorage.getItem('organizationId');
                        that.$store.state.isNotCertified = sessionStorage.getItem('isNotCertified');
                        that.$store.state.isNotCertifiedPerson = sessionStorage.getItem('isNotCertifiedPerson');
                        that.$store.state.companyName = sessionStorage.getItem('companyNameUser');
                        if (that.$store.state.isNotCertifiedPerson == 0 || that.$store.state
                            .isNotCertifiedPerson == 7) {
                            that.status = true;
                        }
                    }
                });
            },
            getCompanyInfo() {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "userDetails/findPerson", {
                    params: {
                        id: this.$route.query.id
                    }
                }).then(res => {
                    if (res.status == 200) {
                        that.isTrue = true;
                        that.companyName = res.data.companyName;
                        that.businessRegistrationNumber = res.data.businessRegistrationNumber;
                        that.companyPermitSj = res.data.companyPermitSj;
                        that.content = res.data.content;
                        that.note = res.data.note;
                        if (res.data.businessLicense.indexOf('http') != -1) {
                            that.img1 = res.data.businessLicense;
                            that.img2 = res.data.dangerousGoodsBusinessLicense;
                        } else {
                            that.img1 = that.$store.state.imgUrl + res.data.businessLicense;
                            that.img2 = that.$store.state.imgUrl + res.data.dangerousGoodsBusinessLicense;
                        }
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    /deep/ .el-input-group__append,
    .el-input-group__prepend {
        font-size: 14px;
        color: #D70606;
        background-color: #FFFFFF;
    }

    /deep/ .el-icon-location-information {
        color: #D70606;
    }

    /deep/ .el-cascader {
        width: 100%;
    }

    #Geren {
        width: 920px;
        margin: 0 auto;
        height: 1041px;
        background: #FFFFFF;
        border-radius: 10px;
        padding: 28px;
        box-sizing: border-box;

        .without {
            text-align: left;
        }

        .withoutcloe {
            color: #999999;
        }

        .withoutcloeBook {
            color: #D70606;
        }

        .without-xian {
            margin-bottom: 26px;
            margin-top: 26px;
            height: 1px;
            background: #E6E6E6;
        }

        .basic {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            text-align: left;
            margin-bottom: 20px;
        }

        /deep/ .el-textarea__inner {
            min-height: 157px !important;
            border-radius: 5px;
        }

        .err {
            text-align: left;
            color: #FF5454;
            font-size: 16px;
        }

        .mkousssa {
            text-align: left;
            margin-left: 75px;
            font-size: 16px;
            color: #999999;
        }

        .moloua {
            font-size: 14px;
            color: #999999;
            line-height: 48px;
            text-align: left;
            min-height: 50px;
        }

        .niasa {
            margin-top: 10px;
            font-size: 14px;
            color: #D70606;
        }

        .add {
            width: 35px;
            height: 35px;
            margin: 0 auto;
            color: #ccc;
            transition: color .25s;
            overflow: hidden;
            padding-bottom: 26px;
        }

        .add::before {
            content: '';
            position: absolute;
            left: calc(50% - 0);
            top: 35%;
            width: 36px;
            margin-left: -18px;
            margin-top: -5px;
            border-top: 6px solid;
        }

        .add::after {
            content: '';
            position: absolute;
            left: 50%;
            top: 33%;
            height: 36px;
            margin-left: -3px;
            margin-top: -17px;
            border-left: 6px solid;
        }
    }

    .avatar-uploader {
        width: 326px;
        height: 200px;
        background: #EBF1FF;
        border-radius: 10px;
        box-sizing: border-box;
        text-align: center;
    }

    .avatar-uploader .avatar {
        width: 326px;
        height: 200px;
        border-radius: 10px;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload--text {
        width: 100%;
        height: 100%;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 36px;
        color: #BAD0FF;
        margin-top: 20px;
    }

    .avatar-uploader-txt {
        font-size: 14px;
        color: #82ABFF;
        width: 326px;
        height: 200px;
    }

    .avatar-uploader-txt>img {
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/view/me/geren.vue